import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import TextArea from '../../atoms/TextArea';
import { useJoin } from '../../contexts/JoinContext';
import JoinActionButton from './JoinActionButton';
import JoinSkipButton from './JoinSkipButton';
import { DashlineSeparator, FlexContainer, SeparatorLine, VerticalSeparator } from './styledElements';
import breakpoints from '../../theme/material/breakpoints';

const StyledContainer = styled('div')({
  marginTop: 'unset',
  [breakpoints.down('sm')]: {
    marginTop: 30,
  },
});

const JoinAboutMeAndIdealDate: React.FC = () => {
  const {
    currentFormData,
    nextStep,
    setCurrentFormData,
    prevStep,
    handleShowSkipModal,
    setSkippedStepCounter,
    currentStepIndex,
  } = useJoin();
  const [shouldDisableNextButton, setShouldDisableNextButton] = useState(false);

  useEffect(() => {
    const shouldEnable =
      (currentFormData.description && currentFormData.description.length >= 50 && !currentFormData.seeking) ||
      (currentFormData.seeking &&
        currentFormData.seeking.length >= 50 &&
        currentFormData.description &&
        currentFormData.description.length >= 50) ||
      (currentFormData.seeking && currentFormData.seeking.length >= 50 && !currentFormData.description);

    setShouldDisableNextButton(!shouldEnable);
  }, [currentFormData]);

  return (
    <StyledContainer>
      <TextArea
        placeholder="Let people know some fun facts about who you are and what you're into. Icebreakers for your dates!"
        inputLabel="Tell everyone a little bit about yourself"
        customStyle={{ paddingBottom: 10 }}
        value={currentFormData.description}
        minCount={50}
        showCounter={true}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setCurrentFormData({ description: event.target.value });
        }}
        customLabelStyle={{ letterSpacing: -0.32, color: '#595959', fontSize: 15, fontWeight: 600 }}
      />
      <DashlineSeparator />
      <TextArea
        placeholder="Dinner, drinks and going for a walk after? What's your ideal first date?"
        inputLabel="What does your ideal first date look like?"
        value={currentFormData.seeking}
        minCount={50}
        showCounter={true}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setCurrentFormData({ seeking: event.target.value });
        }}
        customLabelStyle={{ letterSpacing: -0.32, color: '#595959', marginRight: 0, fontSize: 15, fontWeight: 600 }}
        customStyle={{ paddingBottom: 25 }}
      />

      <DashlineSeparator style={{ marginTop: 0, marginBottom: 0 }} />

      <div style={{ textAlign: 'center' }}>
        <JoinActionButton
          label="Next"
          isDisabled={shouldDisableNextButton}
          isDefault={true}
          onClick={() => {
            nextStep();
            setSkippedStepCounter(prev => ({ ...prev, [currentStepIndex]: false }));
          }}
          customStyle={{ marginBottom: 10 }}
        />

        <FlexContainer>
          <VerticalSeparator>
            <JoinSkipButton label="Back" onClick={() => prevStep()} />
            <SeparatorLine />
            <JoinSkipButton
              label="Skip"
              onClick={() =>
                handleShowSkipModal(() => {
                  if (currentFormData.description && currentFormData.description.length < 50) {
                    setCurrentFormData({
                      description: '',
                    });
                  }

                  if (currentFormData.seeking && currentFormData.seeking.length < 50) {
                    setCurrentFormData({ seeking: '' });
                  }

                  nextStep();
                  setSkippedStepCounter(prev => ({ ...prev, [currentStepIndex]: true }));
                })
              }
            />
          </VerticalSeparator>
        </FlexContainer>
      </div>
    </StyledContainer>
  );
};

export default JoinAboutMeAndIdealDate;
